import { useState } from 'react'
import { Input, InputGroup, InputLeftElement, Select, HStack, Button, Spinner, Flex, useBreakpointValue } from '@chakra-ui/react'

import { Search } from 'components/icons'
import { useMapCoreManager } from '../../../../contexts/MapCoreManager/Provider'

import getLatLonWithZipCode from './utils/getLatLonWithZipCode'
import { AFACodeDecode } from 'components/tools/ImpactoMap/contexts/MapCoreManager/utils/AFACodeDecode'
import { MapPin } from 'components/tools/ImpactoMap/types'
import { MaskedInput } from 'components/dataEntry'
import { cepMask, afaCodeMask } from 'utils/masks'

type SearchType = 'CEP' | 'AFACODE'

export default function SearchInput() {
   const isMobile = useBreakpointValue({ base: true, sm: true, md: false })
  const { _getMarkingData, mapInstance, view, setSelectedEntity } = useMapCoreManager()

  const [query, setQuery] = useState('')
  const [type, setType] = useState<SearchType>('CEP')
  const [loading, setLoading] = useState(false)

  async function handleSearch() {
    if (!query) return

    switch (type) {
      case 'CEP':
        const response = await getLatLonWithZipCode({
          setLoading,
          zipCode: query,
        })

        if (response) {
          _getMarkingData(response)
        }
        break

      case 'AFACODE':
        AFACodeDecode({
          AFA_CODE: query,
          mapInstance,
          view,
          _getMarkingData,
          openDrawer: (entity: MapPin) => setSelectedEntity(entity),
        })
        break
    }
  }

  return (
    <Flex justifyContent="right" alignItems="end" w="100%" >
      <HStack spacing={2} bg="bgContainer" px={isMobile ? 0 :2} rounded="md">
        {/* 🔍 Ícone */}
        <InputGroup size="md" maxW={isMobile ? '0px' : '60px'} >
          <InputLeftElement pointerEvents="none">
            {loading ? <Spinner /> : <Search boxSize={isMobile ? 6: 10} color="primary" />}
          </InputLeftElement>
          <Input visibility="hidden" />
        </InputGroup>

        {/* 📦 Select */}
        <Select value={type} onChange={(e) => setType(e.target.value as SearchType)} maxW={isMobile ? '120px' : '140px'}  fontSize={isMobile ? 'xs' : 'auto'}>
          <option value="CEP">CEP</option>
          <option value="AFACODE">AFACODE</option>
        </Select>

        {/* ✍️ Input */}
        {type === 'CEP' && (
          <MaskedInput
            maxW={isMobile ? '200px' : '200px'}
            mask={cepMask}
            flex={1}
            value={query}
            onChange={(e: any) => setQuery(e.target.value)}
            placeholder={isMobile ? 'Digite' : 'Digite o CEP'}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') handleSearch()
            }}
          />
        )}
        {type === 'AFACODE' && (
          <MaskedInput
           maxW={isMobile ? '200px' : '200px'}
            mask={afaCodeMask}
            flex={1}
            value={query}
            onChange={(e: any) => setQuery(e.target.value)}

            placeholder={isMobile ? 'Digite' : 'Digite o código AFA'}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') handleSearch()
            }}
          />
        )}
        {/* <Input
          maxW="200px"
          flex={1}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={type === 'CEP' ? 'Digite o CEP' : 'Digite o AFACode'}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSearch()
          }}
        /> */}

        {/* 🚀 Botão */}
        <Button onClick={handleSearch} isLoading={loading} colorScheme="blue">
          Buscar
        </Button>
      </HStack>
    </Flex>
  )
}
